import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BlogCustomModelPopup = loadAsyncComponent(() => import('./Container'), 'popup');
